import { render } from "./StatTile.vue?vue&type=template&id=1c2e5e11&ts=true"
import script from "./StatTile.vue?vue&type=script&lang=ts"
export * from "./StatTile.vue?vue&type=script&lang=ts"

import "./StatTile.vue?vue&type=style&index=0&id=1c2e5e11&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__